import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import api from "@/lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function PaymentResult({ status }) {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get("session_id");
  const [state, setState] = useState(status === "cancel" ? "cancelled" : "checking");
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (status === "cancel" || !sessionId) return;
    let active = true;
    const poll = async () => {
      if (attempts >= 8) { if (active) setState("timeout"); return; }
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (!active) return;
        if (data.payment_status === "paid") { setState("success"); return; }
        if (["expired", "failed"].includes(data.payment_status)) { setState("failed"); return; }
        setTimeout(() => setAttempts((a) => a + 1), 2000);
      } catch { if (active) setState("failed"); }
    };
    poll();
    return () => { active = false; };
  }, [attempts, sessionId, status]);

  const config = {
    checking: { icon: Loader2, spin: true, color: "text-primary", title: "Vérification du paiement...", text: "Merci de patienter quelques secondes." },
    success: { icon: CheckCircle2, color: "text-primary", title: "Paiement réussi !", text: "La cotisation a bien été enregistrée." },
    cancelled: { icon: XCircle, color: "text-yellow-500", title: "Paiement annulé", text: "Vous avez annulé le paiement." },
    failed: { icon: XCircle, color: "text-destructive", title: "Paiement échoué", text: "Une erreur est survenue." },
    timeout: { icon: Loader2, color: "text-yellow-500", title: "En cours de traitement", text: "Le paiement met plus de temps que prévu." },
  }[state];

  const C = config.icon;

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <div className="bg-card border border-border rounded-2xl p-10 max-w-md text-center animate-fade-up">
        <C className={`mx-auto ${config.color} ${config.spin ? "animate-spin" : ""}`} size={64} />
        <h1 className="font-display text-3xl font-black uppercase tracking-tight mt-6">{config.title}</h1>
        <p className="text-muted-foreground mt-2">{config.text}</p>
        <Link to="/cotisations" data-testid="back-to-cotisations"
          className="inline-block mt-8 h-11 px-6 leading-[44px] rounded-lg bg-primary text-primary-foreground font-bold text-sm hover:bg-primary/90 transition-colors">
          Retour aux cotisations
        </Link>
      </div>
    </div>
  );
}
